var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 27,
    viewBox: "0 0 17 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1380_1822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.83251 18.5C4.49104 18.5 4.21479 18.2485 4.21479 17.9376V16.624H2.6187C2.27722 16.624 2.00098 16.3725 2.00098 16.0616V7.06245C2.00098 6.75153 2.27722 6.5 2.6187 6.5H10.1694C10.5109 6.5 10.7872 6.75153 10.7872 7.06245V8.37598H12.3871C12.7286 8.37598 13.0048 8.62751 13.0048 8.93843V17.9376C13.0048 18.2485 12.7286 18.5 12.3871 18.5H4.83251ZM4.95145 17.8293H12.2605V9.04673H4.95528V17.8258L4.95145 17.8293ZM2.7338 15.9533H4.21095V8.93843C4.21095 8.62751 4.4872 8.37598 4.82867 8.37598H10.0428V7.17074H2.73764V15.9498L2.7338 15.9533Z",
    fill: "#004ECB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.13701 10.1367H11.2207C11.3166 10.1367 11.3934 10.2066 11.3934 10.2939V10.6503C11.3934 10.7376 11.3166 10.8075 11.2207 10.8075H6.13701C6.04109 10.8075 5.96436 10.7376 5.96436 10.6503V10.2939C5.96436 10.2066 6.04109 10.1367 6.13701 10.1367Z",
    fill: "#004ECB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.13701 12.0476H11.2207C11.3166 12.0476 11.3934 12.1175 11.3934 12.2048V12.5611C11.3934 12.6485 11.3166 12.7183 11.2207 12.7183H6.13701C6.04109 12.7183 5.96436 12.6485 5.96436 12.5611V12.2048C5.96436 12.1175 6.04109 12.0476 6.13701 12.0476Z",
    fill: "#004ECB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.13701 13.9585H11.2207C11.3166 13.9585 11.3934 14.0284 11.3934 14.1157V14.472C11.3934 14.5594 11.3166 14.6292 11.2207 14.6292H6.13701C6.04109 14.6292 5.96436 14.5594 5.96436 14.472V14.1157C5.96436 14.0284 6.04109 13.9585 6.13701 13.9585Z",
    fill: "#004ECB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.13701 15.8694H8.55417C8.65009 15.8694 8.72683 15.9393 8.72683 16.0266V16.3864C8.72683 16.4738 8.65009 16.5436 8.55417 16.5436H6.13701C6.04109 16.5436 5.96436 16.4738 5.96436 16.3864V16.0301C5.96436 15.9427 6.04109 15.8729 6.13701 15.8729V15.8694Z",
    fill: "#004ECB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1380_1822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 12,
    fill: "white",
    transform: "translate(2.00098 6.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.a2d096059e92381edc76078cb7b74213.svg";
export { ForwardRef as ReactComponent };